import React, { isValidElement } from "react";
import styled, { css } from "styled-components";
import breakpoint from "../../../../../utils/breakpoint";
import getColor from "../../../../../utils/getColor";
import getTextColor from "../../../../../utils/getTextColor";
import isObject from "../../../../../utils/isObject";
import space from "../../../../../utils/space";
import { cssTextAtm } from "../../../../atoms/TextAtm/TextAtm.styled";
import { biggerScreenBreakpoint } from "../../common";
var IconFalseSvg = function IconFalseSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m6.71 5.5 4.11-4.11a.6.6 0 0 0 0-.85l-.36-.36a.6.6 0 0 0-.42-.18.6.6 0 0 0-.43.18l-4.1 4.1L1.38.19A.6.6 0 0 0 .96 0a.6.6 0 0 0-.42.18L.18.54a.6.6 0 0 0 0 .85l4.1 4.11-4.1 4.11a.6.6 0 0 0-.18.43c0 .16.06.31.18.42l.36.36a.6.6 0 0 0 .42.18.6.6 0 0 0 .43-.18l4.11-4.1 4.11 4.1a.6.6 0 0 0 .43.18.6.6 0 0 0 .42-.18l.36-.36a.6.6 0 0 0 .18-.42.6.6 0 0 0-.18-.43L6.72 5.5z"
  }));
};
IconFalseSvg.defaultProps = {
  width: "11",
  height: "11",
  xmlns: "http://www.w3.org/2000/svg"
};
var IconTrueSvg = function IconTrueSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M15.7.3c-.4-.4-1-.4-1.4 0L5.9 8.52 1.7 4.46c-.4-.4-1-.4-1.4 0-.4.4-.4.99 0 1.39l4.9 4.85c.4.4 1 .4 1.4 0l9.1-8.92c.4-.5.4-1.09 0-1.48z"
  }));
};
IconTrueSvg.defaultProps = {
  width: "16",
  height: "11",
  xmlns: "http://www.w3.org/2000/svg"
}; // eslint-disable-next-line no-shadow
export var CellAlign = /*#__PURE__*/function (CellAlign) {
  CellAlign["LEFT"] = "left";
  CellAlign["CENTER"] = "center";
  CellAlign["RIGHT"] = "right";
  return CellAlign;
}({});
var Text = styled.p.withConfig({
  componentId: "sc-yp1gzp-0"
})(function (_ref) {
  var $onColor = _ref.$onColor,
    theme = _ref.theme,
    $align = _ref.$align;
  return css(["", ";", "{", ";}strong{color:", ";font-weight:inherit;}span{", "{display:none;}}", ""], cssTextAtm({
    typography: "nano2",
    onColor: $onColor
  }), breakpoint(biggerScreenBreakpoint), cssTextAtm({
    typography: "small3",
    onColor: $onColor
  }), getColor(theme, "primary"), breakpoint("small", biggerScreenBreakpoint), $align && css(["", "{padding:", " ", ";}"], breakpoint(biggerScreenBreakpoint), space(1), space(3)));
});
var IconTrue = styled(IconTrueSvg).withConfig({
  componentId: "sc-yp1gzp-1"
})(function (_ref2) {
  var theme = _ref2.theme;
  return css(["fill:", ";"], getColor(theme, "success"));
});
var IconFalse = styled(IconFalseSvg).withConfig({
  componentId: "sc-yp1gzp-2"
})(function (_ref3) {
  var $onColor = _ref3.$onColor,
    theme = _ref3.theme;
  return css(["fill:", ";"], getTextColor(theme, $onColor, "medium"));
});
function Value(_ref4) {
  var value = _ref4.value,
    onColor = _ref4.onColor,
    ariaLabels = _ref4.ariaLabels;
  var text;
  var strong;
  var suffix;
  var state;
  var align;
  if (typeof value === "string" || typeof value === "number") {
    text = value;
  } else if (/*#__PURE__*/isValidElement(value)) {
    text = value;
    state = "ReactNode";
  } else if (isObject(value)) {
    if ("align" in value) {
      align = value.align;
      text = value.text;
    } else {
      var cellValue = value;
      text = cellValue.text;
      strong = cellValue.strong;
      suffix = cellValue.suffix;
    }
  } else {
    state = value;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, state === "ReactNode" && text, state === undefined && /*#__PURE__*/React.createElement(Text, {
    $onColor: onColor,
    $align: align
  }, text || null, strong ? /*#__PURE__*/React.createElement("strong", null, strong) : null, suffix ? /*#__PURE__*/React.createElement("span", null, " ", suffix) : null), state === true && /*#__PURE__*/React.createElement("p", {
    "aria-label": ariaLabels.iconTrueAriaLabel
  }, /*#__PURE__*/React.createElement(IconTrue, null)), state === false && /*#__PURE__*/React.createElement("p", {
    "aria-label": ariaLabels.iconFalseAriaLabel
  }, /*#__PURE__*/React.createElement(IconFalse, {
    $onColor: onColor
  })));
}
export default Value;